import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=a5cb71a0"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=a5cb71a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default,TlmTab: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmTab.vue').default,FallbackImage: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/FallbackImage.vue').default})
